import CourseDropdown from "../../../Common/Component/CourseDropdown"
import { Btn } from "../../../AbstractElements"
import { CardBody } from "reactstrap"
import SeachBar from "../../UiKits/SearchBar"
import { Table } from "antd"
import { getAttDataColumn } from "../../../utils/attendanceColumn"
import FiltersDropdown from "../../../Common/Component/FiltersDropdown"
import BarcodeIcon from "../../Icons/BarcodeIcon"
import { useState, useEffect, useRef } from "react"
import { toast } from "react-toastify"

const AttendanceHeader = ({ createAttendance, search, setSearch, attStatus, activeCourse, setCreateAttendance, composeAllEmail, filterBy, setAttendanceSheet, setFilterBy, SaveAttendance, attendanceSearch, handleSearchByDate, loading, attendanceSheet }) => {
  const [barcodOpen, setBarcodOpen] = useState(false);
  const [itemCode, setItemCode] = useState('');
  const inputRef = useRef(null);
  const errorSound = new Audio('../../../assets/audio/beep-warning.mp3');

  useEffect(() => {
    const interval = setInterval(() => {
      inputRef.current.focus();
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (itemCode) {
        const match = itemCode.match(/studentId=(\d+)\/email=([^/]+)/);
        if (match) {
          const studentId = match[1];
          const email = match[2];
          SaveAttendance(studentId, email)
        } else {
          errorSound.play();
          toast.error('Student ID Not Found')
        }
        setItemCode('')
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [itemCode]);

  return (
    <>
      <div className='fee-table-header'>
        <div className="header-row">
          <CourseDropdown isAttendance={true} selectCourse={activeCourse?.id} />
          <SeachBar search={search} setSearch={setSearch} loading={loading} />
        </div>
        <div className="fee-data">
          <Table
            columns={getAttDataColumn()}
            bordered={true}
            pagination={false}
            scroll={{ x: "auto" }}
            loading={!Object.keys(attStatus).length}
            dataSource={[attStatus]} />
        </div>
        <div className="header-row m-t-20">
          {/* <CardBody className="dropdown-basic p-0">
            <CourseDropdown />
          </CardBody> */}
          <div>
          {!attendanceSheet && (
              <Btn className="px-4" style={{ width: "180px" }} attrBtn={{
                onClick: () => setCreateAttendance(!createAttendance),
                color: "primary",
                disabled: !activeCourse || loading,
              }}>
                {createAttendance ? 'Close Attendance' : 'Create Attendance'}
              </Btn>
            )}
          </div>
          <div>
            <Btn className="w-auto px-4" attrBtn={{
              onClick: () => composeAllEmail(),
              color: "primary",
              disabled: !activeCourse || loading,
            }}>
              Email All
            </Btn>
          </div>
          <FiltersDropdown isAttendance={true} setAttendanceSheet={setAttendanceSheet} filterBy={filterBy} setFilterBy={setFilterBy} />
          <button
            onClick={() => setBarcodOpen(!barcodOpen)}
            className="btn border-0 shadow-none focus-ring-0 p-0 mx-4 d-flex align-items-center justify-content-center"
            disabled={loading}
          >
            <BarcodeIcon color={barcodOpen ? '#65C8FE' : '#1F2937'} />
          </button>
          <div>
          <input
            id="date"
            disabled={!activeCourse || loading}
            value={attendanceSearch}
            onChange={(e) => handleSearchByDate(e.target.value)}
            className="form-control text-black w-40 h-10 mx-auto rounded px-3"
            type="date"
            placeholder="Select Date"
            max={new Date().toISOString().split("T")[0]}
            />
            </div>
          <input
            placeholder="Barcode Value"
            name="student_code"
            value={itemCode}
            disabled={!barcodOpen || loading}
            ref={inputRef}
            id="item_code"
            className="position-fixed end-0 opacity-0 border-0 shadow-none"
            onChange={(e) => {
              setItemCode(e.target.value);
            }}
          />
        </div>
      </div>
    </>
  )
}

export default AttendanceHeader